export default "__VITE_ASSET__$34EDmsa__"